import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import FinsightModal from '@/creditflowresearch/ui/common/components/FinsightModal';
import ModalFormRepository from '@/creditflowresearch/infrastructure/repository/ModalFormRepository';
import { AlertManager } from '@dealroadshow/uikit-alert';
import JoinWaitlistForm from './JoinWaitlistForm';
import { IJoinWaitlistFormValues } from './interfaces';

const JoinWaitlistModal = ({ closeModal, isOpen }: { closeModal: () => void, isOpen: boolean }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [isSubmitSucceed, setIsSubmitSucceed] = useState(false);

  const closeModalHandler = () => {
    closeModal();
    setIsSubmitSucceed(false);
  };

  const container = getContainer();
  const modalFormRepository = container.get<ModalFormRepository>(ModalFormRepository);

  const onSubmit = async (values: IJoinWaitlistFormValues) => {
    setIsFetching(true);

    try {
      const token = await values.recaptcha.executeAsync();
      const response = await modalFormRepository.joinOpenmarketWaitlist({
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        comment: values.comment ?? '',
        token,
      });

      if (response.result === 'error') {
        throw new Error(response.reason);
      }

      setIsSubmitSucceed(true);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <FinsightModal
      hideOnOverlayClicked
      modalTitle={ (
        <>
          Sign up for the OpenMarket <br /> Waitlist
        </>
      ) }
      isFetching={ isFetching }
      isSuccessOverlay
      isSubmitSucceed={ isSubmitSucceed }
      isVisible={ isOpen }
      dataTest="requestServiceModal"
      onCloseClicked={ closeModalHandler }
      successText="You have joined OpenMarket Waiting list"
    >
      <JoinWaitlistForm onSubmit={ onSubmit } />
    </FinsightModal>
  );
};

export default JoinWaitlistModal;
